export const postMessageToWindow = (eventObject, targetOrigin) => {
    if (window && window.simulator)
        window.top.postMessage(eventObject, targetOrigin);
    else
        window.parent.postMessage(eventObject, targetOrigin);
}